import { MUIDataTableOptions } from "mui-datatables";

export const defaultOptions: MUIDataTableOptions = {
  elevation: 0,
  filter: false,
  selectableRows: 'none',
  responsive: 'vertical',
  viewColumns: false,
  download: true,
  pagination: false,
  print: false,
  rowHover: false,
  search: false,
  sort: true,
  downloadOptions: {
    filename: 'table.csv',
    separator: ',',
  }
};
